import React from 'react';
import classNames from 'classnames';

import { RuleExecutor, LolliRight } from '../Rule';

import Formula from './Formula';
import Connective from './Connective';
import Tensor from './Tensor';
import Statement from '../Statement';

import Operator from '../components/Operator';
import Subformula from '../components/Subformula';

import styles from '../styles/Formula.module.css';

class Lollipop extends Connective {
  toTex(): string {
    return this.left.toTex() + ' \\multimap ' + this.right.toTex();
  }

  negated(): Formula {
    return new Tensor(this.left, this.right.negated());
  }

  equals(that: Formula): boolean {
    return that instanceof Lollipop && super.equals(that);
  }

  private onClick(executor: RuleExecutor) {
    return () => executor(new LolliRight(this));
  }

  render(subgoal: Statement, executor: RuleExecutor): JSX.Element {
    const isRoot = subgoal.hasFormula(this.id);
    const isRequirement = subgoal.hasRequirement(this.id, true);
    const isEnabled = isRoot && isRequirement;

    return (
      <div
        className={classNames(
          styles.formula,
          styles.connective,
          styles.lollipop
        )}
      >
        <Subformula>{this.left.render(subgoal, executor)}</Subformula>

        <Operator
          name="⊸"
          onClick={isEnabled ? this.onClick(executor) : undefined}
        />

        <Subformula>{this.right.render(subgoal, executor)}</Subformula>
      </div>
    );
  }
}

export default Lollipop;
